import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_USER_INFO } from '../queries/userQueries.js';
import Spinner from './Spinner';
import AuditSymbolCompliance from './AuditSymbolCompliance';

const formatDate = (timestamp) => {
  const date = new Date(Number(timestamp));
  return {
    date: date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }),
    time: date.toLocaleTimeString('en-US'),
  };
};

const MDMLogRow = ({ logData }) => {
  const { loading, error, data } = useQuery(GET_USER_INFO, {
    variables: { userId: logData.Requester },
    skip: !logData.Requester,
  });

  const dates = useMemo(() => ({
    request: formatDate(logData.createdAt),
    response: formatDate(logData.updatedAt),
  }), [logData.createdAt, logData.updatedAt]);

  const requesterName = logData.Requester ? (data?.lookupUser?.name ?? '—') : 'System';

  if (logData.Requester && loading) return <tr><td colSpan="4"><Spinner /></td></tr>;
  if (logData.Requester && error) return <tr><td colSpan="4">Benutzer nicht gefunden</td></tr>;

  return (
    <tr className={logData.Response ? '' : 'table-danger'}>
      <td>{`${dates.request.date} ${dates.request.time}`}</td>
      <td>{logData.RequestType}</td>
      <td>{requesterName}</td>
      <td>
        {logData.Response ? (
          <>
            <AuditSymbolCompliance status={logData.Response === 'Acknowledged'} />
            {` ${dates.response.date} ${dates.response.time}`}
            {logData.Response === 'Error' && logData.ErrorDetails && (
              <div className="small text-danger mt-1" title={logData.ErrorDetails}>
                {logData.ErrorDetails.length > 80 ? `${logData.ErrorDetails.slice(0, 80)}…` : logData.ErrorDetails}
              </div>
            )}
          </>
        ) : logData.PushResult ? (
          <span className="text-muted" title="Befehl an Gerät gesendet, Antwort ausstehend">
            Push: {logData.PushResult.slice(0, 8)}…
          </span>
        ) : (
          'keine Antwort'
        )}
      </td>
    </tr>
  );
};

export default React.memo(MDMLogRow, (prevProps, nextProps) => {
  return prevProps.logData.CommandUUID === nextProps.logData.CommandUUID;
});
